export enum WriterValueType {
	Field = 1,
	FreeTextOrExpression = 2,
}
